module.exports = __webpack_public_path__ + "static/media/Snapshot Vid_1719420573470.9944df1c. Script 05 2024";